import React, { useEffect, useState } from 'react';
import { AppSelectBase } from '..';
import classNames from 'classnames';
import useLocationFetcher from '@/presentation/hooks/use-location-fetcher';
import { decodeValue, encodeValue } from '@/presentation/utils/location-utils';
const CountryStateCity = ({ manageCountriesStateCities, handleDataChange, customStyles, defaultValues }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const [state, setState] = useState({
        fieldCountry: null,
        fieldState: null,
        fieldCity: null
    });
    const { countries, states, cities, isCityLoading, isStateLoading, isCountryLoading } = useLocationFetcher({
        manageCountriesStateCities,
        countryCode: (_b = decodeValue((_a = state.fieldCountry) === null || _a === void 0 ? void 0 : _a.value)) === null || _b === void 0 ? void 0 : _b.iso2,
        stateCode: (_d = decodeValue((_c = state.fieldState) === null || _c === void 0 ? void 0 : _c.value)) === null || _d === void 0 ? void 0 : _d.iso2,
        cityCode: (_g = (_f = decodeValue((_e = state.fieldCity) === null || _e === void 0 ? void 0 : _e.value)) === null || _f === void 0 ? void 0 : _f.id) === null || _g === void 0 ? void 0 : _g.toString()
    });
    const [defaultCountry, setDefaultCountry] = useState((defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.fieldCountry) || null);
    const [defaultState, setDefaultState] = useState((defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.fieldState) || null);
    const [defaultCity, setDefaultCity] = useState((defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.fieldCity) || null);
    useEffect(() => {
        setState(prev => (Object.assign(Object.assign({}, prev), { fieldCity: null })));
    }, [(_h = state.fieldState) === null || _h === void 0 ? void 0 : _h.value]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        if (handleDataChange) {
            handleDataChange({
                idCountry: ((_b = decodeValue((_a = state.fieldCountry) === null || _a === void 0 ? void 0 : _a.value)) === null || _b === void 0 ? void 0 : _b.id) || null,
                idState: ((_d = decodeValue((_c = state.fieldState) === null || _c === void 0 ? void 0 : _c.value)) === null || _d === void 0 ? void 0 : _d.id) || null,
                idCity: ((_f = decodeValue((_e = state.fieldCity) === null || _e === void 0 ? void 0 : _e.value)) === null || _f === void 0 ? void 0 : _f.id) || null
            });
        }
    }, [state.fieldCountry, state.fieldState, state.fieldCity]);
    // default values START
    useEffect(() => {
        if (countries.length > 0 && defaultCountry) {
            const internalCountry = countries.find(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.toString()) === (defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.toString()); });
            if (internalCountry) {
                setState(prev => (Object.assign(Object.assign({}, prev), { fieldCountry: { label: internalCountry.name, value: encodeValue(internalCountry) } })));
                setDefaultCountry(null);
            }
        }
    }, [defaultCountry, countries.length]);
    useEffect(() => {
        if (states.length > 0 && defaultState) {
            const internalState = states.find(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.toString()) === (defaultState === null || defaultState === void 0 ? void 0 : defaultState.toString()); });
            if (internalState) {
                setState(prev => (Object.assign(Object.assign({}, prev), { fieldState: { label: internalState.name, value: encodeValue(internalState) } })));
                setDefaultState(null);
            }
        }
    }, [defaultState, states.length]);
    useEffect(() => {
        if (cities.length > 0 && defaultCity) {
            const internalState = cities.find(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.toString()) === (defaultCity === null || defaultCity === void 0 ? void 0 : defaultCity.toString()); });
            if (internalState) {
                setState(prev => (Object.assign(Object.assign({}, prev), { fieldCity: { label: internalState.name, value: encodeValue(internalState) } })));
                setDefaultCity(null);
            }
        }
    }, [defaultCity, cities.length]);
    // default values END
    const optionsCountry = countries.map(country => ({ label: country.name, value: encodeValue(country) }));
    const optionsState = states.map(state => ({ label: state.name, value: encodeValue(state) }));
    const optionsCity = cities.map(city => ({ label: city.name, value: encodeValue(city) }));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames(customStyles === null || customStyles === void 0 ? void 0 : customStyles.classCountryWrap) },
            React.createElement(AppSelectBase, { state: state, options: optionsCountry, setState: setState, name: 'fieldCountry', label: 'COUNTRY', placeholder: 'ie. United States', isLoading: isCountryLoading, isSearchable: true, onChangeAditionalSetState: {
                    fieldState: null,
                    fieldCity: null
                }, required: true })),
        React.createElement("div", { className: classNames(customStyles === null || customStyles === void 0 ? void 0 : customStyles.classStateWrap) },
            React.createElement(AppSelectBase, { state: state, options: optionsState, setState: setState, name: 'fieldState', label: 'STATE/PROVINCE/REGION', placeholder: 'ie. ' + (states.length > 0 ? states[0].name : 'Florida'), isLoading: isStateLoading, isSearchable: true, onChangeAditionalSetState: {
                    fieldCity: null
                }, required: true })),
        React.createElement("div", { className: classNames(customStyles === null || customStyles === void 0 ? void 0 : customStyles.classCityWrap) },
            React.createElement(AppSelectBase, { state: state, options: optionsCity, setState: setState, name: 'fieldCity', label: 'CITY', placeholder: 'ie. ' + (cities.length > 0 ? cities[0].name : 'Tampa'), isLoading: isCityLoading, isSearchable: true }))));
};
export default CountryStateCity;
